export default __webpack_public_path__ + "static/media/logo combrailles.f9a8239f.jpg";